import { Link } from "react-router-dom";
import img from "../../assets/img/illu/illu-hero.webp";

import { useTranslation } from "react-i18next"; // ✅ POUR i18n

export default function Hero() {
  const { t, i18n } = useTranslation(); // ✅ DÉCLARATION de i18n ici

  // ✅ DÉCLARATION de la fonction toggleLang
  const toggleLang = () => {
    const nextLang = i18n.language === "fr" ? "en" : "fr";
    i18n.changeLanguage(nextLang);
  };

  return (
    <div className="Hero" id="main">
      <div className="fade" key={i18n.language}>
        <h1>{t("hero.title")}</h1>
        <p className="desc">{t("hero.desc1")}</p>
        <img className="mobile" src={img} alt="" />
        <p>{t("hero.desc2")}</p>
        <p>{t("hero.desc3")}</p>
      </div>
      <img src={img} alt="" />
      <Link className="button">{t("hero.button")}</Link>
    </div>
  );
}
